import React from 'react';
import MonacoEditor from '@monaco-editor/react';
import { useTheme } from '@mui/material';

interface SqlEditorProps {
  query: string;
  onChange: (value: string) => void;
}

const SqlEditor: React.FC<SqlEditorProps> = ({ query, onChange }) => {
  const theme = useTheme();
  const editorTheme = theme.palette.mode === 'dark' ? 'vs-dark' : 'light';
  return (
    <MonacoEditor
      height="250px"
      defaultLanguage="sql"
      theme={editorTheme}
      value={query}
      onChange={(value) => onChange(value ?? '')}
      options={{
        minimap: { enabled: false },
        fontSize: 14,
        lineNumbers: 'on',
        automaticLayout: true,
      }}
    />
  );
};

export default SqlEditor;
